module.exports = __webpack_public_path__ + "img/about_brands_content_img.d4707ec9.png";